import Ad from "../gpt/Ad";

/**
 * Abstract TaglessAdHandler class
 * @class TaglessAdHandler
 */
export default class TaglessAdHandler {

  baseUrl: string | null = null;

  constructor(baseUrl: string) {
      this.baseUrl = baseUrl;
  }

  /**
   * Abstract method used to decorate ad container and iframe
   * Child class should override this method
   * @param {html} iframe
   * @param {html} container
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  decorateAd(iframe: HTMLElement, container: HTMLElement, googleIframeContainer?: HTMLElement): void {}

  /**
   * Abstract method used to generate ad iframe src
   * Child class can override this method to add parames
   * @param {Ad} ad
   * @returns
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getAdSrc(ad: Ad): string | null {
      return this.baseUrl;
  }

  /**
   * Method to render ad
   * @param {Ad} ad
   */
  render(ad: Ad): void {
      const iframe: HTMLIFrameElement = document.createElement("iframe");
      const containerId: string = ad.getContainerId();
      const container: HTMLElement | null = document.getElementById(containerId);

      const url: string | null = this.getAdSrc(ad);

      if (!url || !container) {
          return;
      }

      iframe.src = url;
      iframe.title = `iframe-${ containerId }`;

      this.decorateAd(iframe, container);

      container.appendChild(iframe);

      ad.dispatchEvent("render", ad.getSlotRenderedEvent());
  }

}
